import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { clusterService } from '@/api/services/cluster';
import { platformService } from '@/api/services/platform';
import { head } from '@/router/Head';
import { clusterListSearchSchema } from '@/router/utils';

export const Route = createFileRoute('/_authenticated/_dashboard/accounts/$accountId/clusters/')({
  validateSearch: clusterListSearchSchema,
  staticData: {
    title: 'Clusters',
  },
  shouldReload: () => false,
  beforeLoad: async ({ context: { queryClient }, params: { accountId } }) => {
    // The first deployment choice of an empty list reads the providers. Public, so no permission to check.
    const listCloudProvidersQuery = platformService.listCloudProvidersQuery({ accountId });
    void queryClient.prefetchQuery(listCloudProvidersQuery);

    const listClustersQuery = clusterService.listClustersQuery({ accountId });
    await queryClient.fetchQuery(listClustersQuery);

    return { listClustersQuery, listCloudProvidersQuery };
  },
  head,
  pendingMs: 100,
  component: lazyRouteComponent(() => import('@/components/Clusters/ClustersPage'), 'ClustersIndexComponent'),
  pendingComponent: lazyRouteComponent(() => import('@/components/Clusters/ClustersPage'), 'ClusterPendingComponent'),
});
